import PT from 'prop-types';

// mui imports
import { CardContent, Typography, Box } from '@mui/material';

// icons
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

const CardHeader = ({ title, toggle, setToggle }) => {
  return (
    <CardContent
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
      <Typography variant="sh4">{title.toUpperCase()}</Typography>
      <Box
        as="span"
        sx={{ color: 'dark.main', fontSize: '1.2rem', cursor: 'pointer' }}
        onClick={() => setToggle(!toggle)}>
        {toggle ? <FaAngleDown size={30} /> : <FaAngleUp size={30} />}
      </Box>
    </CardContent>
  );
};

CardHeader.propTypes = {
  title: PT.string.isRequired,
  toggle: PT.bool.isRequired,
  setToggle: PT.func.isRequired
};

export default CardHeader;
